
import * as React from 'react'
import { Text, View, TouchableOpacity, Dimensions, } from 'react-native'
import { useTheme } from '@react-navigation/native'
import moment from 'moment'
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { TabView, SceneMap } from 'react-native-tab-view'
import TeamGeneral from './TeamGeneral'

const initialLayout = { width: Dimensions.get('window').width };

export default React.memo(function TabTeam({ navigation, route }) {
    const { colors } = useTheme()
    const insets = useSafeAreaInsets()
    const [month_string, setMonthString] = React.useState(moment().format('MM/YYYY'))
    const [month_string_label, setMonthStringLabel] = React.useState(moment().format('MM/YYYY'))
    const [index, setIndex] = React.useState(0);
    const [routes] = React.useState([
        { key: 'first', title: 'Tổng quan' },

    ]);
    const renderScene = ({ route }) => {
        switch (route.key) {
            case 'first':
                return <TeamGeneral month_string={month_string} />

        }
    }

    React.useEffect(() => {
        if (route.params?.full_date) {
            setMonthString(moment(route.params?.full_date, 'YYYY-MM-DD').format('MM/YYYY'))
            setMonthStringLabel(moment(route.params?.full_date, 'YYYY-MM-DD').format('MM/YYYY'))
        }
    }, [route.params?.full_date])

    return (
        <View style={{ flex: 1 }}>
            <View style={{ paddingHorizontal: 16, marginBottom: 3, paddingTop: insets.top ? insets.top : 14, alignItems: 'center', flexDirection: 'row' }}>
                <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', marginLeft: 11, flex: 1, fontSize: 32 }}>Nhân sự</Text>
                <TouchableOpacity onPress={() => navigation.navigate('ModalCalendar', { tab_screen: 'team', month_string: month_string })}>
                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>{month_string_label}</Text>
                </TouchableOpacity>
            </View>
            <View style={{ flexDirection: 'row', marginLeft: 22 }}>
                <TouchableOpacity style={{ borderBottomWidth: 1, borderBottomColor: index ? 'transparent' : colors.text, marginRight: 8, paddingBottom: 6 }}
                    onPress={() => setIndex(0)}>
                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>Tổng quan</Text>
                </TouchableOpacity>

            </View>
            <TabView
                navigationState={{ index, routes }}
                renderScene={renderScene}
                onIndexChange={setIndex}
                initialLayout={initialLayout}
                renderTabBar={() => null}
            />
        </View>
    );
})